module.exports = __webpack_public_path__ + "img/Tier 1 Alternative 1.379e6bcd.jpg";